<p class="invite-user-title">{{ 'header.invite_user.invite_user_txt' | translate }}</p>
<p class="easy-sub-title">{{ 'header.invite_user.add_10_users' | translate }}</p>

<form [formGroup]="emailForm" autocomplete="off" (ngSubmit)="inviteUsers()" class="easy-form">
  <div formArrayName="emails">
    <div *ngFor="let email of formEmails.controls; let i = index" [formGroupName]="i" fxLayout="row" fxLayoutAlign="space-between center">
      <mat-form-field class="w-260 mt-8" appearance="outline">
        <input matInput formControlName="email" placeholder="Email Id" />
        <mat-error *ngFor="let validation of validationMsgs.email">
          <div *ngIf="email.get('email').hasError(validation.type)">
            {{validation.message}}
          </div>
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="user-admin">
        <mat-select formControlName="role" panelClass="no-change">
          <mat-option *ngFor="let role of roles" [value]="role.id">
            {{role.value}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <dp-svg [src]="SvgMap.uds_delete" tooltip="Remove" [color]="formEmails.controls.length === 1 ? '' :'var(--primary-brand-main)'" [disabled]="formEmails.controls.length === 1" (click)="removeOrClearEmail(i)" class="delete-icon"></dp-svg>
      <div>
        <!-- <button class="float-left" style="margin-left: 5px; margin-right: 5px;" type="button" mat-icon-button color="primary"
          aria-label="Add" (click)="addEmailFormGroup()" tooltip="Add"
          *ngIf="i === formEmails.controls.length - 1 && formEmails.controls.length <= 9">
          <mat-icon>add_circle_outline</mat-icon>
        </button>
        <button mat-icon-button type="button" color="primary" aria-label="Remove/clear" (click)="removeOrClearEmail(i)" tooltip="Remove"
          [disabled]="formEmails.controls.length === 1">

          <mat-icon>highlight_off</mat-icon>
        </button> -->
      </div>

    </div>
  </div>

  <button mat-flat-button class="easy-button medium" type="submit" [dpBusy]="isBusy"
    [disabled]="!emailForm.valid || !hasUser() || emailForm.pristine">{{ 'header.invite_user.send_invitation_txt' | translate }}</button>
  <button mat-flat-button class="easy-button medium ml-20 secondary" (click)="addEmailFormGroup($event)"
    [hidden]="formEmails.controls.length >= 10">{{ 'header.invite_user.add_another_user_txt' | translate }}</button>
</form>
